export default "__VITE_ASSET__CBmEhPCs__"